<template>
    <div>
        <form id="formProcesso" @submit.prevent="submit()" class="ajax_off" ref="form">

            <input type="hidden" name="processo_id" v-model="data.id" />

            <div class="form-group">
                <div class="form-group" v-if="!externo">
                    <clientes-select modal v-model="data.cliente_id" />
                </div>
                <div class="form-group">
                    <label>Selecione o Orgão</label>
                    <e-select :reload="orgao_reload" name="orgao" modal="orgao" route="orgaoList" v-model="data.orgao_id" />
                </div>
                <div class="form-group campo_formulario_processo processo_numero" v-if="data.cliente_id">
                    <label>Número do processo ou protocolado</label>
                    <input type="text" name="processo_numero" class="form-control" v-model="data.processo_numero"
                        placeholder="Número do processo ou protocolado" required="" />
                </div>
                <div class="form-group campo_formulario_processo processo_ano" v-if="data.cliente_id">
                    <label>Ano do processo</label>
                    <input type="number" v-model="data.processo_ano" minlength="4" maxlength="4" name="processo_ano"
                        class="form-control" placeholder="Ano do Processo" required="" />
                </div>

                <div class="form-group campo_formulario_processo processo_status" v-if="!automatizado && data.cliente_id">
                    <label>Status</label>
                    <e-select name="status" v-model="data.status_id" route="processo/status" />
                </div>

                <div class="
                                    form-group
                                    campo_formulario_processo
                                    processo_automatizadoprocesso_setor
                                  " v-if="!automatizado && data.cliente_id">
                    <label>Setor (local)</label>
                    <input type="text" id="setor" name="processo_setor" v-model="data.setor" class="form-control"
                        placeholder="Secretaria/Setor" />
                </div>

                <div class="form-group campo_formulario_processo processo_notificar_dias"
                    v-if="!automatizado && data.cliente_id">
                    <label>Ser notificado a cada
                        <input type="number" style="text-align: center; width: 50px" :min="notificar_dias"
                            name="processo_notificar_dias" v-model="data.processo_notificar_dias" class=""
                            placeholder="Dias" value="PROCESSOS_NOTIFICAR_DIAS" required="" />
                        dias</label>
                </div>

                <div class="form-group campo_formulario_processo processo_identificador" style="display: none">
                    <input type="text" name="processo_identificador" class="form-control"
                        placeholder="Identificador do Processo" />
                </div>
                <div class="form-group campo_formulario_processo chave" style="display: none">
                    <input type="text" name="processo_chave" class="form-control" placeholder="Chave do Protocolo" />
                </div>
                <div class="form-group" v-if="data.cliente_id">
                    <label>Tipo</label>
                    <e-select name="tipo" route="processo/tipoList" v-model="data.tipo_id" />
                </div>
            </div>
        </form>
        <modal id="orgao" form="orgaoForm" btn_save size="md" title="Cadastrar Orgao">
            <orgao-form @created="orgaoCreated" />
        </modal>
        <modal id="confirmarEmail" title="Confirmação de email" form="checkEmail" size="md" btn_save
            btn_save_name="Confirmar">
            <form id="checkEmail" @submit.prevent="confirmEmail()" class="ajax_off">
                <label for="confirm-email">O email para receber as notificações deste processo está correto?.</label><br>
                <small>Caso não esteja, por favor substituia-o pelo email correto.</small>
                <input type="email" name="email" class="form-control" v-if="cliente" v-model="cliente.email"
                    id="confirm-email" />
            </form>
        </modal>
    </div>
</template>

<script>
import eSelect from "../../sistema/eSelect.vue";
import clienteForm from "../../clientes/forms/clienteForm.vue";
import orgaoForm from "./OrgaoForm.vue";
import eModal from "../../sistema/eModal";
import ClientesSelect from "../../sistema/ClientesSelect.vue";
import { result } from "lodash";

export default {
    components: { eSelect, clienteForm, orgaoForm, eModal, ClientesSelect },
    props: {
        cliente: Object,
        externo: Boolean,
    },
    data() {
        return {
            orgao_reload: false,
            notificar_dias: 7,
            result_created: null,
            cliente: null,
            data: {
                id: "",
                processo_numero: "",
                processo_ano: new Date().getFullYear(),
                setor: "",
                cliente_id: null,
                status_id: "",
                orgao_id: null,
                tipo_id: "",
                processo_notificar_dias: 7,
                tipo_id: "",
            },
            automatizado: false,
        };
    },
    created() {
        if (this.externo) {
            this.data.cliente_id = this.cliente.id;
        }
    },
    watch: {
        "data.cliente_id": function () {
            this.vericarMunicipio();
            this.getCliente();
        },
    },
    methods: {
        orgaoCreated(orgao_id) {
            this.orgao_reload = true;
            this.data.orgao_id = orgao_id;
            setTimeout(() => {
                this.orgao_reload = false;
            }, 1000);
        },
        async submit() {

            this.data.externo = this.externo;
            if (this.id) {
                this.result_created = await this.$api.put("processo", this.data);
            } else {
                this.result_created = await this.$api.post("processo", this.data);

                if (this.result_created.data && !this.result_created.data.warning && this.automatizado) {
                    this.$bvModal.show("confirmarEmail");
                } else if (!this.automatizado) {
                    this.close();
                }
            }
        },

        close() {
            this.$bvModal.hide("confirmarEmail");

            if (this.externo) {
                this.$emit("processoCriado", this.result_created.data);
            } else {
                this.$bvModal.hide("processo");
            }

        },

        async confirmEmail() {
            await this.$api.put(`cliente/${this.data.cliente_id}`, this.cliente).then((result) => {
                this.close();
            })


        },

        async getCliente() {
            let result = await this.$api.get(`cliente/${this.data.cliente_id}`);
            this.cliente = result.data;
        },

        async vericarMunicipio() {
            const result = await this.$api.get(
                `cliente/isMunicipioAutomatizado/${this.data.cliente_id}`
            );

            if (result.data) {
                if (result.data.processo_automatizado === true) {
                    this.automatizado = true;
                } else {
                    this.automatizado = false;
                }
            }
        },
    },
};
</script>

